import axios from "axios/index";

export default {
  createAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations',
      method: "POST",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/ADD_AUTOMATION', response.data, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  createLimitedAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/limited/automations',
      method: "POST",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/ADD_AUTOMATION', response.data, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  enableAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + payload.id + '/enable',
      method: "PUT",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/REPLACE_AUTOMATION', { id: payload.id, data: response.data }, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  silentAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + payload.id + '/silent',
      method: "PUT",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/REPLACE_AUTOMATION', { id: payload.id, data: response.data }, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + payload.id,
      method: "PUT",
      data: JSON.stringify(payload.data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/REPLACE_AUTOMATION', { id: payload.id, data: response.data }, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteAutomation: ({ commit }, id) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + id,
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('automations/DELETE_AUTOMATION', id, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  testAutomation: ({ commit }, params) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + params.id + '/test',
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof params['callback'] === "function") {
          params['callback'](response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  runAutomation: ({ commit }, params) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + params.id + '/run',
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof params['callback'] === "function") {
          params['callback'](response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  delayAutomation: ({ commit }, params) => {
    const { delay } = params;
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + params.id + '/delayed/' + delay,
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof params['callback'] === "function") {
          params['callback'](response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  duplicateAutomation: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/automations/' + payload.id + '/duplicate',
      method: "POST",
      data: JSON.stringify(payload.data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(response.data);
        // commit('automations/REPLACE_AUTOMATION', {id: payload.id, data: response.data}, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  runByPin: ({ commit }, params) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const { callback, pin, target } = params;
    axios({
      url: '/engine/runbypin/' + target,
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Butler-Pin': pin,
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof callback === "function") {
          callback(null, response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
        if (typeof callback === "function") {
          callback(err);
        }
      });
  }
};
